import $ from 'jquery';
import "../utils/_megamenu";

const settings = {
    /* prefix for generated unique id attributes, which are required
       to indicate aria-owns, aria-controls and aria-labelledby */
    uuidPrefix: "tc-megamenu",

    /* css class used to define the megamenu styling */
    menuClass: "js-nav",

    /* css class for a top-level navigation item in the megamenu */
    topNavItemClass: "js-nav-top-item",

    /* css class for a megamenu panel */
    panelClass: "nav__submenu-wrap",
    openOnMouseover: false,
    /* css class for a group of items within a megamenu panel */
    panelGroupClass: "nav__submenu",

    /* css class for the hover state */
    hoverClass: "hover",

    /* css class for the focus state */
    focusClass: "focus",

    /* css class for the open state */
    openClass: "open"
}

$(document).ready(() => {
    $('.js-menu').tcMegaMenu(settings);
});